module.exports = __webpack_public_path__ + "static/media/img-footer-bg.3bdf2888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-footer-bg.svg
// module id = 684
// module chunks = 0